const SellersRoutes = [
  {
    path: "/seller-management",
    component: () => import("@/components/sellers/SellerManagement"),
  },
{
	path: "/sellers/:userSetupId",
	name: "SellerDetails",
	component: () => import("@/components/sellers/SellerDetail"), // Adjust path accordingly
  props: true,
  },
  {
    path: '/sellers/:sellerId/factoring/:id',
    name: 'FactoringRequestView',
    component: () => import("@/components/sellers/FactoringRequestView"),
    props: true,
  },
  {
    path: '/sellers/:userId/orders/:orderId',
    name: 'seller-order-details',
    component: () => import("@/components/sellers/orders/OrderDetails"),
    props: true,
  },
  {
    path: '/sellers/:userId/consignments/:consignmentId',
    name: 'ConsignmentDetails',
    component: () => import('@/components/sellers/stock/ConsignmentDetails'),
    props: true,
  },
  {
    path: '/sellers/:userId/allocation/:allocationId',
    name: 'AllocationDetails',
    component: () => import('@/components/sellers/stock/AllocationDetails'),
    props: true,
  },
  {
    path: '/sellers/:userSetupId/products/:productId',
    name: 'ProductDetails',
    component: () => import('@/components/sellers/product-catalog/ProductDetails.vue'),
    props: true,
  },
  {
    path: '/sellers/:userSetupId/key-accounts/:accountId',
    name: 'KeyAccountDetails',
    component: () => import('@/components/sellers/key-accounts/KeyAccountDetails.vue'),
    props: true,
  },
  {
    path: '/sellers/:userId/fulfill-order/:orderId',
    name: 'FulfillOrder',
    component: () => import('@/components/sellers/orders/FulfillOrder.vue'),
    props: true,
  },
  {
    path: '/seller/consignment-order-details/:userId/:consignmentId',
    name: 'ConsignmentOrderDetails',
    component: () => import('@/components/sellers/ConsignmentOrderDetails.vue'),
    props: true
  }
];

export default SellersRoutes;
